import { create } from 'zustand';

interface SpectatorState {
  downedSelf: boolean;
  watchedAllyId: string | null;
  setDowned: (v: boolean) => void;
  setWatchedAlly: (id: string | null) => void;
  reset: () => void;
}

export const useSpectatorStore = create<SpectatorState>((set) => ({
  downedSelf: false,
  watchedAllyId: null,
  setDowned: (downedSelf) => set({ downedSelf, watchedAllyId: null }),
  setWatchedAlly: (watchedAllyId) => set({ watchedAllyId }),
  reset: () => set({ downedSelf: false, watchedAllyId: null }),
}));
